import BaseAPIService from './baseAPI';
import {
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  RegisterResponse,
  SendOtpRequest,
  SendOtpResponse,
  User,
  VerifyOtpLoginRequest,
  VerifyOtpRegisterRequest,
} from '../types/api';

class AuthAPIService extends BaseAPIService {
  constructor() {
    super();
  }

  async login(credentials: LoginRequest): Promise<LoginResponse> {
    // Create URLSearchParams for OAuth2 style login (application/x-www-form-urlencoded)
    const formData = new URLSearchParams();
    formData.append('username', credentials.username);
    formData.append('password', credentials.password);

    const response = await this.postFormUrlEncoded<LoginResponse>('/auth/login', formData);
    
    // Store token in localStorage - handle nested structure
    if (response.data?.access_token) {
      localStorage.setItem('token', response.data.access_token);
    }
    
    return response;
  }

  async register(userData: RegisterRequest): Promise<RegisterResponse> {
    return this.post<RegisterResponse>('/auth/register', userData);
  }

  async sendOtp(data: SendOtpRequest): Promise<SendOtpResponse> {
    return this.post<SendOtpResponse>('/auth/otp/send', data);
  }

  async verifyOtpRegister(data: VerifyOtpRegisterRequest): Promise<LoginResponse> {
    const response = await this.post<LoginResponse>('/auth/otp/verify-register', data);
    if (response.data?.access_token) {
      localStorage.setItem('token', response.data.access_token);
    }
    return response;
  }

  async verifyOtpLogin(data: VerifyOtpLoginRequest): Promise<LoginResponse> {
    const response = await this.post<LoginResponse>('/auth/otp/verify-login', data);
    if (response.data?.access_token) {
      localStorage.setItem('token', response.data.access_token);
    }
    return response;
  }

  async getCurrentUser(): Promise<{ data: User }> {
    return this.get<{ data: User }>('/auth/me');
  }

  async updateProfile(userData: Partial<User>): Promise<{ data: User }> {
    return this.put<{ data: User }>('/auth/profile', userData);
  }

  async changePassword(data: { current_password: string; new_password: string }): Promise<{ message: string }> {
    return this.post<{ message: string }>('/auth/change-password', data);
  }

  async requestPasswordReset(email: string): Promise<{ message: string }> {
    return this.post<{ message: string }>('/auth/forgot-password', { email });
  }

  async resetPassword(data: { token: string; new_password: string }): Promise<{ message: string }> {
    return this.post<{ message: string }>('/auth/reset-password', data);
  }

  async refreshToken(): Promise<LoginResponse> {
    return this.post<LoginResponse>('/auth/refresh');
  }

  async logout(): Promise<{ message: string }> {
    // Clear local storage
    localStorage.removeItem('token');
    return this.post<{ message: string }>('/auth/logout');
  }
}

export const authAPI = new AuthAPIService();
export default authAPI; 